import type { ChatSessionResponse } from "@agent-service-types/index.ts";
import { format, parseISO } from "date-fns";
import type { AdvisingSession } from "./types";

export const formatSessionDate = (session: ChatSessionResponse): string =>
  session.created_at ? format(parseISO(session.created_at), "M/d/yyyy") : "";

export const toAdvisingSession = (session: ChatSessionResponse): AdvisingSession => {
  const date = formatSessionDate(session);
  const firstName = session.first_name ?? "";
  const lastName = session.last_name ?? "";
  return {
    id: session.id,
    title: session.title ?? `Advising Session on ${date}`.trimEnd(),
    date,
    topics: session.chat_sessions_advising_topics?.map((t) => t.name) ?? [],
    summary: session.summary ?? "",
    rating: session.rating_feedback ?? 0,
    feedback: session.text_feedback ?? "",
    warning: undefined,
    userName: `${firstName} ${lastName}`.trim(),
    chatInteractions: session.chat_interactions ?? [],
  };
};
